<template>
  <div class="life-page">
    <section class="life-panel">
      <div class="life-panel__head">
        <h2 class="life-panel__title">产品查询</h2>
        <el-button type="primary" icon="el-icon-plus" size="small" @click="openEditor()">新增产品</el-button>
      </div>
      <div class="life-filter">
        <el-input v-model="filters.name" placeholder="产品名称" clearable style="width: 180px" @keyup.enter.native="search" />
        <el-input v-model="filters.externalProductId" placeholder="外部产品 ID" clearable style="width: 160px" @keyup.enter.native="search" />
        <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
        <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
      </div>
    </section>

    <section class="life-panel">
      <div class="life-panel__head">
        <h2 class="life-panel__title">上门产品</h2>
      </div>
      <el-table v-loading="loading" :data="rows" border>
        <el-table-column prop="name" label="产品名称" min-width="140" />
        <el-table-column prop="externalProductId" label="外部产品 ID" width="120" />
        <el-table-column prop="catalogName" label="分类" width="100" />
        <el-table-column label="预付价" width="110" align="center">
          <template slot-scope="scope">
            <span class="life-money">{{ scope.row.prepayAmount }}</span>
            <span style="color: #8a93a5"> /{{ scope.row.priceUnit || '次' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="maxQuantity" label="最大数量" width="90" align="center" />
        <el-table-column label="封面" width="80" align="center">
          <template slot-scope="scope">
            <el-image v-if="scope.row.coverUrl" :src="getImageUrl(scope.row.coverUrl)" fit="cover" style="width: 50px; height: 50px" :preview-src-list="[getImageUrl(scope.row.coverUrl)]" />
            <span v-else class="life-muted">-</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="80" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.state === '1002' ? 'success' : 'warning'" size="small">
              {{ scope.row.state === '1002' ? '上架' : '未上架' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="sort" label="排序" width="70" align="center" />
        <el-table-column prop="createTime" label="创建时间" width="170" />
        <el-table-column label="操作" width="140" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" icon="el-icon-edit" @click="openEditor(scope.row)">编辑</el-button>
            <el-button type="text" icon="el-icon-delete" style="color: #f56c6c" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination class="life-pagination" :current-page.sync="page.current" :page-size="page.size"
        :page-sizes="[10, 20, 50]" :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="changeSize" @current-change="load" />
    </section>

    <el-dialog :title="form.productId ? '编辑产品' : '新增产品'" :visible.sync="editorVisible" width="640px" @closed="onDialogClosed">
      <el-form ref="formRef" :model="form" :rules="rules" label-width="110px">
        <el-form-item label="产品名称" prop="name">
          <el-input v-model="form.name" maxlength="128" />
        </el-form-item>
        <el-form-item label="外部产品 ID" prop="externalProductId">
          <el-input v-model="form.externalProductId" maxlength="32" />
        </el-form-item>
        <el-form-item label="分类名称">
          <el-input v-model="form.catalogName" maxlength="64" />
        </el-form-item>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="预付价(元)" prop="prepayAmount">
              <el-input v-model="form.prepayAmount" placeholder="0.00" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="计价单位">
              <el-select v-model="form.priceUnit" style="width: 100%">
                <el-option label="次" value="次" />
                <el-option label="小时" value="小时" />
                <el-option label="天" value="天" />
                <el-option label="件" value="件" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="最大数量">
          <el-input-number v-model="form.maxQuantity" :min="1" :max="99" controls-position="right" style="width: 100%" />
        </el-form-item>
        <el-form-item label="封面图">
          <div class="cover-upload">
            <div v-if="coverPreview" class="cover-item">
              <el-image :src="coverPreview" fit="cover" style="width: 100px; height: 100px" :preview-src-list="[coverPreview]" />
              <i class="el-icon-delete cover-del" @click="removeCover" />
            </div>
            <div v-if="!coverPreview" class="cover-btn" @click="$refs.coverInput.click()">
              <i class="el-icon-plus" />
            </div>
            <input ref="coverInput" type="file" accept="image/*" hidden @change="handleCoverFile" />
          </div>
        </el-form-item>
        <el-form-item label="产品描述">
          <el-input v-model="form.description" type="textarea" :rows="2" maxlength="1024" show-word-limit />
        </el-form-item>
        <el-form-item label="预约须知">
          <el-input v-model="form.noticeText" type="textarea" :rows="2" maxlength="2048" show-word-limit />
        </el-form-item>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="状态">
              <el-radio-group v-model="form.state">
                <el-radio label="1002">上架</el-radio>
                <el-radio label="1001">未上架</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="排序">
              <el-input-number v-model="form.sort" :min="0" :max="9999" controls-position="right" style="width: 100%" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button @click="editorVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { listProducts, saveProduct, updateProduct, deleteProduct } from '@/api/life/homeServiceApi'
import { uploadFile } from '@/api/staff/addStaffApi'

function emptyForm() {
  return {
    productId: '', name: '', externalProductId: '', catalogName: '',
    prepayAmount: '', priceUnit: '次', maxQuantity: 1, coverUrl: '',
    description: '', noticeText: '', state: '1001', sort: 0
  }
}

export default {
  name: 'HomeServiceProductList',
  data() {
    return {
      loading: false, saving: false, editorVisible: false,
      coverPreview: '',
      rows: [],
      filters: { name: '', externalProductId: '' },
      page: { current: 1, size: 10, total: 0 },
      form: emptyForm(),
      rules: {
        name: [{ required: true, message: '请输入产品名称', trigger: 'blur' }],
        externalProductId: [{ required: true, message: '请输入外部产品 ID', trigger: 'blur' }],
        prepayAmount: [
          { required: true, message: '请输入预付价', trigger: 'blur' },
          { pattern: /^\d+(\.\d{1,2})?$/, message: '请输入正确的金额', trigger: 'blur' }
        ]
      }
    }
  },
  created() { this.load() },
  methods: {
    async load() {
      this.loading = true
      try {
        const res = await listProducts({ ...this.filters, page: this.page.current, row: this.page.size })
        this.rows = res.data || []
        this.page.total = Number(res.total || 0)
      } catch (error) {
        this.$message.error(error.message || '加载产品列表失败')
      } finally { this.loading = false }
    },
    search() { this.page.current = 1; this.load() },
    reset() { this.filters = { name: '', externalProductId: '' }; this.search() },
    changeSize(size) { this.page.size = size; this.load() },
    getImageUrl(url) {
      if (!url) return ''
      if (url.startsWith('http') || url.startsWith('https') || url.startsWith('data:')) return url
      return `/callComponent/download/getFile/file?fileId=${url}&communityId=-1`
    },
    openEditor(row) {
      if (row) {
        this.form = { ...row, maxQuantity: Number(row.maxQuantity) || 1, sort: Number(row.sort) || 0 }
        this.coverPreview = row.coverUrl ? this.getImageUrl(row.coverUrl) : ''
      } else {
        this.form = emptyForm()
        this.coverPreview = ''
      }
      this.editorVisible = true
      this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate())
    },
    onDialogClosed() {
      this.$refs.formRef && this.$refs.formRef.resetFields()
      this.coverPreview = ''
      this.form = emptyForm()
    },
    handleCoverFile(e) {
      const file = e.target.files[0]
      if (!file) return
      if (file.size > 2 * 1024 * 1024) {
        this.$message.error('图片大小不能超过2MB')
        e.target.value = null
        return
      }
      const reader = new FileReader()
      reader.onload = (ev) => { this.coverPreview = ev.target.result }
      reader.readAsDataURL(file)
      const formData = new FormData()
      formData.append('uploadFile', file)
      formData.append('communityId', '-1')
      uploadFile(formData).then(({ fileId }) => {
        this.form.coverUrl = fileId
        this.$message.success('上传成功')
      }).catch(error => {
        this.$message.error(error.message || '上传失败')
        this.coverPreview = ''
      })
      e.target.value = null
    },
    removeCover() {
      this.coverPreview = ''
      this.form.coverUrl = ''
    },
    submit() {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        const amount = Number(this.form.prepayAmount)
        if (!Number.isFinite(amount) || amount <= 0) {
          this.$message.warning('预付价必须大于 0')
          return
        }
        this.saving = true
        try {
          const payload = { ...this.form, maxQuantity: String(this.form.maxQuantity), sort: String(this.form.sort) }
          if (this.form.productId) {
            await updateProduct(payload)
          } else {
            await saveProduct(payload)
          }
          this.$message.success('产品信息已保存')
          this.editorVisible = false
          this.load()
        } catch (error) {
          this.$message.error(error.message || '保存失败')
        } finally { this.saving = false }
      })
    },
    handleDelete(row) {
      this.$confirm(`确认删除产品「${row.name}」？`, '提示', { type: 'warning' }).then(async () => {
        try {
          await deleteProduct({ productId: row.productId })
          this.$message.success('已删除')
          if (this.rows.length === 1 && this.page.current > 1) this.page.current--
          this.load()
        } catch (error) {
          this.$message.error(error.message || '删除失败')
        }
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/views/lifeService/life.scss';

.cover-upload {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  .cover-item {
    position: relative;
    .cover-del {
      position: absolute;
      top: -6px;
      right: -6px;
      color: #f56c6c;
      font-size: 16px;
      cursor: pointer;
      background: #fff;
      border-radius: 50%;
      padding: 2px;
      box-shadow: 0 1px 4px rgba(0,0,0,.15);
    }
  }
  .cover-btn {
    width: 100px;
    height: 100px;
    border: 1px dashed #dcdfe6;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #909399;
    font-size: 24px;
    &:hover { border-color: #409eff; color: #409eff; }
  }
}
</style>
